import { CGCardSize } from 'components/Product/CardMaster';
import React from 'react';
// import React,{ useContext } from 'react';
// import { collectionsContext } from '../../contexts/CollectionsContext';
import { CGProduct } from '../../types/shopify';
import ProductCardSlider from '../Product/ProductCardSlider';
import { useHistory } from 'react-router-dom';
import debug from 'debug';
import { useCollection } from 'effects/useCollection';
import ProductGrid from 'components/ProductGrid/ProductGrid';
import Box from '@mui/material/Box';
const d = debug('dynamicCollection');

interface DynamicCollectionProps {
  handle: string;
  title?: string;
  variant?: 'CAROUSEL' | 'SLIDER' | 'GRID';
  cardSize?: CGCardSize;
  onCloseDrawer?: () => void;
  padFirstAndLast?: boolean;
}

const DynamicCollection: React.FC<DynamicCollectionProps> = (props: any) => {
  const { title, handle, variant = 'SLIDER', cardSize, onCloseDrawer, padFirstAndLast = false } = props;
  // const { getCollectionByHandle } = useContext(collectionsContext);
  // const Collection = getCollectionByHandle(handle);

  const { collection, error } = useCollection(handle);
  const history = useHistory();
  const handleProductClick = (product: CGProduct) => {
    history.push('/product/' + product.handle);
    onCloseDrawer && onCloseDrawer();
  };

  const handleCollectionClick = () => {
    history.push('/landing/' + handle);
    onCloseDrawer && onCloseDrawer();
  };

  if (!collection || error) return null;
  d(handle, variant, title);
  if (variant === 'GRID') {
    return (
      <>
        <Box
          sx={{
            typography: 'h3',
            pb: 2,
          }}
        >
          {title || 'View All ' + collection.title}
        </Box>
        <ProductGrid products={collection.products} />
      </>
    );
  }
  return (
    <ProductCardSlider
      // slider
      forceCardSize={cardSize}
      title={title === '' ? title : title || collection.title}
      items={collection.products}
      onClick={handleProductClick}
      onClickTitle={handleCollectionClick}
      padFirstAndLast={padFirstAndLast}
    />
  );
};

export default DynamicCollection;
